module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/~/core-js/library/modules/$.add-to-unscopables.js
 ** module id = 1498
 ** module chunks = 3
 **/